import React, { useEffect } from "react";
import { Header } from "../components/Header";
import { Hero } from "../components/sections/Hero";
import { About } from "../components/sections/About";
import { Services } from "../components/sections/Services";
import { Team } from "../components/sections/Team";
import { GlobalPresence } from "../components/sections/GlobalPresence";
import { News } from "../components/sections/News";
import { LeadMagnet } from "../components/sections/LeadMagnet";
import { Contact } from "../components/sections/Contact";
import { Footer } from "../components/sections/Footer";
import { CookieBanner } from "../components/CookieBanner";
import { useLanguage } from "../contexts/LanguageContext";
import { applySEO } from "../lib/seo";

export default function HomePage() {
  const { lang } = useLanguage();

  useEffect(() => {
    applySEO({
      title: lang === "fr"
        ? "Société d'investissement internationale — Port Louis"
        : "International Investment Firm — Port Louis",
      description:
        lang === "fr"
          ? "Richild Invest GBC — Société d'investissement internationale basée à Port Louis, Île Maurice. Private Equity, Debt Finance, Trade Finance, Advisory et Impact Investing à travers 12 bureaux dans le monde."
          : "Richild Invest GBC — International investment firm headquartered in Port Louis, Mauritius. Private Equity, Debt Finance, Trade Finance, Advisory and Impact Investing across 12 offices worldwide.",
      url: "https://richildinvest.com/",
      type: "website",
      lang,
    });
  }, [lang]);

  return (
    <div data-testid="home-page" className="bg-white min-h-screen overflow-x-hidden">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Team />
        <GlobalPresence />
        <News />
        <LeadMagnet />
        <Contact />
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
